// import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom';

// import App from './app/app';

// ReactDOM.render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
//   document.getElementById('root')
// );


import React from "react";
import "../src/assets/index.scss";
import { App } from "./app/App";
import { BrowserRouter as Router } from "react-router-dom";
import { CustomerContextProvider } from "./context/Customer";

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <CustomerContextProvider>
          <App />
      </CustomerContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
